const actions = {
  setParams({
    commit
  }, params) {
    commit('setParams', params);
  },
  setParamsMultilingue({
    commit
  }, params) {
    commit('setParamsMultilingue', params);
  },
  setLangues({
    commit
  }, langues) {
    commit('setLangues', langues)
  },
  setCurrentLang({
    commit,
    state
  }, langue) {
    commit('setParams',
      state.paramsMultilingue.find((p) => p.formParams.language.name === langue)
    );
    commit('setConstantes',
      state.traductions.find((t) => t.langue === langue).traductions
    );
    commit('setCurrentLang', langue)
  },
  setTraductions({
    commit
  }, value) {
    commit('setTraductions', value)
  },
  setConstantes({
    commit
  }, value) {
    commit('setConstantes', value)
  },
  setPersonalInfo({
    commit
  }, personalInfo) {
    commit('setPersonalInfo', personalInfo);
  },
  setJeVeuxFaireUneDedicace({
    commit
  }, dedicace) {
    commit('setJeVeuxFaireUneDedicace', dedicace);
  },
  setDedicaceInfo({
    commit
  }, dedicaceInfo) {
    commit('setDedicaceInfo', dedicaceInfo);
  },
  setContactInfo({
    commit
  }, contactInfo) {
    commit('setContactInfo', contactInfo);
  },
  setDonationInfo({
    commit
  }, donationInfo) {
    commit('setDonationInfo', donationInfo);
  },
  cancelDonation({
    commit
  }) {
    commit('setPersonalInfo', {});
    commit('setContactInfo', {});
    commit('setDonationInfo', {});
  },
  setCampaign({
    commit
  }, campaign) {
    commit('setCampaign', campaign);
  },
  setCampaignSlug({
    commit
  }, slug) {
    commit('setCampaignSlug', slug);
  },
  setCurrentURL({
    commit
  }, url) {
    commit('setCurrentURL', url);
  },
  setInfosPaysafe({
    commit
  }, infosPaysafe) {
    commit('setInfosPaysafe', infosPaysafe);
  }
}

export default actions;